<template>
    <div class="cabinet-content-wrap">
        <header
            class="cabinet-header d-flex align-items-center justify-content-between justify-content-md-start"
        >
            <a
                href="javascript:void(0)"
                class="dashboard__back-link"
                @click="$router.go(-1)"
            ></a>
            <h1 class="h1 cabinet-title pl-3 m-0">Поставщики</h1>
            <div class="pr-3 pl-3 pb-1"></div>
        </header>

        <section class="dashboard-list__section pt-2">
            <div class="filters-panel-search dashboard-list__search">
                <label
                    class="filters-panel-search__label"
                    for="filters-panel-search__input"
                    @click="onSearch"
                ></label>
                <input
                    id="filters-panel-search__input"
                    v-model.trim="search"
                    type="text"
                    class="app-input filters-panel-search__input"
                    placeholder="Юридическое лицо или бренд"
                    @keyup.enter="onSearch"
                />
                <label
                    v-if="search"
                    class="filters-panel-search__clear"
                    for="filters-panel-search__input"
                    @click="onClearSearch"
                ></label>
            </div>

            <div v-if="loading" class="pt-4 mt-3">Loading...</div>

            <div
                v-else-if="!paginatedSuppliers.length"
                class="w-md-50 text-center ml-auto mr-auto pt-5 pb-5"
            >
                <img
                    v-if="!search"
                    src="/img/icons/empty-goods.svg"
                    class="dashboard-empty__img ofi"
                />
                <img
                    v-else
                    src="/img/icons/empty-search.svg"
                    class="dashboard-empty__img dashboard-empty__img--search ofi"
                />
                <div class="dashboard-empty__title pt-5">
                    {{
                        search
                            ? ' По вашему запросу ничего не найдено.'
                            : 'Нет информации.'
                    }}
                </div>
            </div>

            <template v-if="!loading && paginatedSuppliers.length">
                <div class="d-flex justify-content-between pt-4 mt-3">
                    <pagination-info :pagination="pagination" />

                    <div class="d-none d-md-flex">
                        <table-pagination
                            :current-page="pagination.page"
                            :total-pages="pagination.totalPages"
                            :total-products="pagination.totalProducts"
                            @setPage="onSetPage($event)"
                        />
                    </div>
                </div>

                <div class="pt-4">
                    <router-link
                        v-for="supplier in paginatedSuppliers"
                        :key="supplier.id"
                        class="cabinet-table__row link-nostyle flex flex-align-center pt-4 pb-4 pt-md-1 pb-md-1"
                        :to="`/brands/${supplier.brands[0].BrandID}`"
                        target="_blank"
                    >
                        <div class="dashboard-list__cell">
                            <div class="dashboard-list__cell-name">
                                {{ supplier.company_name || supplier.name }}
                            </div>
                            Бренды:
                            {{
                                supplier.brands
                                    .map(brand => `"${brand.BrandName}"`)
                                    .join(', ')
                            }}
                        </div>
                        <div
                            class="d-none d-md-flex flex-wrap justify-content-end ml-auto"
                        >
                            <img
                                v-for="brand in supplier.brands"
                                :key="brand.BrandID"
                                class="dashboard-list__logo-right ofi ml-3 mt-3 mb-3"
                                :src="brand.logo"
                            />
                        </div>
                    </router-link>
                </div>

                <div class="pt-4 pb-5 mb-3">
                    <div class="d-none d-md-flex justify-content-end">
                        <table-pagination
                            :current-page="pagination.page"
                            :total-pages="pagination.totalPages"
                            :total-products="pagination.totalProducts"
                            @setPage="onSetPage($event)"
                        />
                    </div>
                    <div
                        v-if="pagination.page < pagination.totalPages"
                        class="d-flex d-md-none justify-content-center pt-2"
                    >
                        <button
                            type="button"
                            class="cabinet-btn cabinet-btn--default"
                            :disabled="pagination.page >= pagination.totalPages"
                            @click="
                                updateSuppliersList(pagination.page + 1, true)
                            "
                        >
                            Загрузить еще
                        </button>
                    </div>
                </div>
            </template>
        </section>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import _ from 'lodash'
import TablePagination from '@/components/Cabinet/Pagination/TablePagination'
import PaginationInfo from '@/components/Cabinet/Pagination/PaginationInfo'

export default {
    name: 'GlobalSuppliers',
    components: { TablePagination, PaginationInfo },
    data() {
        return {
            loading: true,
            search: ''
        }
    },
    computed: {
        ...mapState('supplierStatsSuppliers', [
            'suppliers',
            'mobileSuppliers',
            'pagination',
            'errors'
        ]),
        paginatedSuppliers() {
            if (document.documentElement.clientWidth > 767) {
                return this.suppliers
            }
            return this.mobileSuppliers
        }
    },
    async mounted() {
        this.updateSuppliersList(1)
    },
    destroyed() {
        this.clearSuppliers()
    },
    methods: {
        ...mapActions('supplierStatsSuppliers', [
            'getSuppliers',
            'clearSuppliers'
        ]),
        ...mapMutations('supplierStatsSuppliers', ['SET_PAGINATION']),
        updateSuppliersList: _.debounce(async function(
            page = 1,
            isMobilePagination = false
        ) {
            let data = { page, isMobilePagination }

            if (this.search) {
                data.search = this.search
            }

            if (isMobilePagination) {
                this.$Progress.start()
            }

            await this.getSuppliers(data)

            if (Object.keys(this.errors.getSuppliers).length) {
                this.$notify({
                    text: 'Ошибка',
                    type: 'error'
                })
            }
            this.loading = false
        },
        800),
        onSetPage(page) {
            let validPage = page
            if (page < 1) {
                validPage = 1
            } else if (page > this.pagination.totalPages) {
                validPage = this.pagination.totalPages
            }

            this.SET_PAGINATION({
                key: 'page',
                val: validPage
            })

            this.$Progress.start()

            this.updateSuppliersList(page)
        },
        onSearch() {
            this.$Progress.start()
            this.updateSuppliersList(1)
        },
        onClearSearch() {
            this.search = ''
            this.$Progress.start()
            this.updateSuppliersList(1)
        }
    }
}
</script>
